export class Contents {
    public static GeographicTitle = "Geographical allocation";
    public static noDataErrorMessage =
        "No data exists against the selected account or date. Please choose a different account or date.";
    public static noDataErrorMessagePerformanceIncom =
        "No data exists against the selected account or date. Please choose a different account, date or table.";
    public static ViewAllRegionNote = "Click on a region name to see the investments detail. ";
    public static SectorSubTitle =
        "This shows a breakdown of your portfolio investments by stock sector groups on the selected date.";
    public static SectorTitle = "Sector allocation";
    public static Geographic = "Geographical allocation";
    public static Cash = "CASH";
    public static Model = "MODEL";
}

export enum AreaGroupTypeMap {
    "UK" = 0,
    "EURO" = 1,
    "USA" = 2,
    "JAP" = 3,
    "ASIA" = 4,
    "EAST" = 5,
    "SAMER" = 6,
    "AFRICA" = 7,
    "CASH" = 8,
    "OTHER" = 9,
    "ALL" = 10,
}
